import { Document, Page, StyleSheet } from "@react-pdf/renderer";
import DefaultPDF from "./variants/default";
import AmsaPDF from "./variants/amsa";
import { enum__Clients } from "../../../../common/Dictionaries";
import BrecaPDF from "./variants/breca";

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
  },
});

function PDFDocument({
  headers,
  partidas,
  incrementos,
  detalles,
  contract,
  polinomios,
  applicationRoles,
  variant = enum__Clients.DEFAULT.toLocaleLowerCase(),
}) {
  const props = {
    headers,
    partidas,
    incrementos,
    detalles,
    contract,
    polinomios,
    applicationRoles,
  };

  let SelectedVariant;
  switch (variant) {
    case enum__Clients.AMSA.toLocaleLowerCase():
      SelectedVariant = AmsaPDF;
      break;
    case enum__Clients.BRECA.toLocaleLowerCase():
      SelectedVariant = BrecaPDF;
      break;
    case enum__Clients.DEFAULT.toLocaleLowerCase():
    default:
      SelectedVariant = DefaultPDF;
      break;
  }
  return (
    <Document>
      <Page size="A4" style={styles.page} orientation="landscape">
        <SelectedVariant {...props} />
      </Page>
    </Document>
  );
}

export default PDFDocument;
